import { LEVEL, LEVEL_PROPERTIES } from '@/interfaces/level.interface'

export default function mergeLevels(
  buildingGeometry: GeoJSON.Polygon | GeoJSON.MultiPolygon,
  features: LEVEL[],
  properties: LEVEL_PROPERTIES[]
): LEVEL[] {
  return features.map((feature) => {
    const match = properties.find((p) => p.id === feature.properties.belongsToId)
    const mergedProperties = match ? { ...feature.properties, ...match } : feature.properties
    if (!feature.geometry) {
      feature.geometry = buildingGeometry
      mergedProperties.geometryFromBuilding = true
    }
    return {
      ...feature,
      id: match?.id || feature.properties.id,
      properties: { ...mergedProperties, belongsToId: match?.id || feature.properties.belongsToId }
    }
  })
}
